import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { Meta, Title } from '@angular/platform-browser';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root',
})
export class MetaManagerService {
  defaultTitle = 'Memorabid - Bid Your Dreams';
  prefix = 'Memorabid - ';
  defaultImage = '/assets/img/preview-logo.png';
  defaultAlt = 'Memorabid';
  defaultDescription =
    'The first Auction House in Europe to be dedicated exclusively to sports memorabilia.';
  defaultOgDescription =
    'The first Auction House in Europe dedicated to sports memorabilia';
  defaultUrl = environment.canonicalUrl;
  defaultAppId = 966242223397117;

  private _metaTagTitleLength = 200;
  private _facebookDescriptionLength = 200;
  private _twitterDescriptionLength = 200;

  constructor(
    private titleService: Title,
    private meta: Meta,
    @Inject(DOCUMENT) private doc: Document
  ) {}

  updateTitleAndMeta(
    title: string,
    description: string,
    urlPage: string,
    urlImage: string
  ) {
    const purifiedTitle = title?.replace(/<[^>]*>?/gm, '') ?? '';
    const purifiedDescription =
      description?.replace(/<[^>]*>?/gm, '')?.replaceAll('&nbsp;', ' ') ?? '';

    this.titleService.setTitle(
      purifiedTitle != ''
        ? purifiedTitle.substring(0, this._metaTagTitleLength)
        : this.defaultTitle
    );
    this.meta.updateTag({
      name: 'description',
      content:
        description != '' ? purifiedDescription : this.defaultDescription,
    });

    // apple
    this.meta.updateTag({
      property: 'apple-mobile-web-app-title',
      content:
        title != ''
          ? title.substring(0, this._metaTagTitleLength)
          : this.defaultTitle,
    });

    //og:tags
    this.meta.updateTag({
      property: 'fb:app_id',
      content: this.defaultAppId.toString(),
    }); // default per togliere il warning in caso di app non presente su facebook
    this.meta.updateTag({
      property: 'og:title',
      content:
        purifiedTitle != ''
          ? purifiedTitle.substring(0, this._metaTagTitleLength)
          : this.defaultTitle,
    });
    this.meta.updateTag({
      property: 'og:description',
      content:
        purifiedDescription != ''
          ? purifiedDescription.substring(
              0,
              this._facebookDescriptionLength - 1
            )
          : this.defaultOgDescription,
    });
    this.meta.updateTag({
      property: 'og:image',
      content: urlImage != '' ? `${urlImage}?w=600` : this.defaultImage,
    });
    this.meta.updateTag({
      property: 'og:url',
      content: urlPage != '' ? urlPage : this.defaultUrl,
    });

    //twitter
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.updateTag({
      name: 'twitter:title',
      content:
        purifiedTitle != ''
          ? purifiedTitle.substring(0, this._metaTagTitleLength)
          : this.defaultTitle,
    });
    this.meta.updateTag({
      name: 'twitter:description',
      content:
        purifiedDescription != ''
          ? purifiedDescription.substring(0, this._twitterDescriptionLength - 1)
          : this.defaultDescription,
    });
    this.meta.updateTag({
      name: 'twitter:image',
      content: urlImage != '' ? `${urlImage}?w=600` : this.defaultImage,
    });
  }

  setNoIndex() {
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });
  }

  removeNoIndex() {
    this.meta.removeTag('name="robots"');
  }
}
